import ChangePassword from './ChangePasswordController';

export default ChangePassword;
